export default function PageHero({ eyebrow, title, description, image = "/assets/ugi-nautical-map.jpg", children, testId }) {
  return (
    <section data-testid={testId} className="relative overflow-hidden bg-[#1C1613] text-[#FDFBF7]">
      <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-85 sepia-[0.22]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1C1613]/95 via-[#1C1613]/70 to-[#1C1613]/25" />
      <div className="relative mx-auto flex min-h-[430px] max-w-7xl flex-col justify-center px-5 py-20 sm:px-8">
        <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#C5A059]">{eyebrow}</p>
        <h1 className="mt-5 max-w-4xl font-serif text-4xl font-normal leading-[1.05] tracking-[-0.03em] sm:text-5xl lg:text-6xl">{title}</h1>
        {description && <p className="mt-6 max-w-2xl text-base font-light leading-8 text-[#E6DED2] sm:text-lg">{description}</p>}
        {children}
      </div>
    </section>
  );
}
